import styled from 'styled-components';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

export const StyledTreeItem = styled(TreeItem)`
  p {
    font-size: 14px;
    font-family: Poppins;
    span {
      font-weight: 600;
    }
  }

  .MuiTreeItem-group {
    margin-left: 25px;
  }

  .MuiTreeItem-content {
    margin-bottom: 6px;
  }

  .MuiTypography-root .MuiTreeItem-label .MuiTypography-body1:focus {
    background: white;
  }

  .MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label {
    background-color: white;
  }

  .MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover,
  .MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label {
    background-color: white;
  }

  .MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label {
    background-color: white;
  }

  .MuiTreeItem-root:focus > .MuiTreeItem-content .MuiTreeItem-label {
    background-color: white !important;
  }

  ${({ haschildren }) =>
    !haschildren &&
    `
.MuiTypography-root {
  background: white !important;
  cursor: default;
 
}

.MuiTreeItem-label {
  background: white !important;
  cursor: text;
}

.MuiTreeItem-content {
  background: white !important;
  cursor: default;
}
`}
`;

export const StyledTreeView = styled(TreeView)`
  .MuiTreeItem-root {
    position: relative;
    left: -3px;
  }

  .MuiTypography-root .MuiTreeItem-label .MuiTypography-body1:focus {
    background: white;
  }

  .MuiTreeItem-root:focus > .MuiTreeItem-content .MuiTreeItem-label:not(:hover) {
    background-color: transparent;
  }
`;
